<template>
  <div>
    <div class="question" v-for="(question, idxQuestion) in this.questions" v-bind:key="idxQuestion">
      <question
        v-if="displayQuestions"
        :ref="idxQuestion"
        :question-index="idxQuestion"
        :question-object="question"
        :is-question-in-emotional-section="sectionTypeName == 'Emotional Needs'"
        :next-sequence-number="questions.length"
        :section-object="sectionObject"
        :input-metric-options="metric_options"
        :input-saved-metric-options="saved_metric_options"
        :input-segment-options="segment_options"
        :input-saved-segment-options="saved_segment_options"
        @save="setSurveyToBuildRequired"
      ></question>
    </div>
  </div>
</template>
<script>
import Question from "../components/Question.vue";

import SectionMixins from "../mixins/SectionMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";

import MetricsService from "../services/metrics.service";
import NeedQuestionService from "../services/need.question.service";
import AdminService from "../services/admin.service";
export default {
  name: "NeedsSection",
  mixins: [SectionMixins, ContentMixins],
  components: {
    Question
  },
  data() {
    return {
      metric_options: [],
      segment_options: [],
      saved_segment_options: [],
      saved_metric_options: [],
      displayQuestions: false,
      driverOptions: [
        { value: 1, name: "Trust" },
        { value: 2, name: "Adaptability" },
        { value: 3, name: "Activity" },
        { value: 4, name: "Creativity" },
        { value: 5, name: "Assurance" }
      ],
      industryFieldOptions: [
        { value: 0, name: "Automotive" },
        { value: 13, name: "Concepts" },
        { value: 1, name: "Consumer Goods" },
        { value: 2, name: "Electronics" },
        { value: 3, name: "Energy" },
        { value: 4, name: "Finance" },
        { value: 12, name: "Generic" },
        { value: 5, name: "Health Care" },
        { value: 6, name: "Industrials & Materials" },
        { value: 7, name: "Media" },
        { value: 14, name: "Restaurants" },
        { value: 8, name: "Retail" },
        { value: 9, name: "Technology" },
        { value: 10, name: "Telecom" },
        { value: 11, name: "Travel & Transport" }
      ]
    };
  },
  props: {
    surveyId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    displayDropdown: function() {
      return this.sectionName == "Actual Functional Needs";
    }
  },
  methods: {
    getNeedQuestionMetricsCallback(response) {
      this.metric_options = [];
      this.metricId = "";
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        MetricsService.setMetricDropdownOptions(response.data.data.options,this);
        this.metric_options = this.metric_options.filter(option => !option.value.includes("-growth"));
        this.saved_metric_options =  response.data.data.savedOptions;
      } else if (statusCode == 201) {
        //        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },  
    getNeedQuestionSegmentsCallback(response) {
      this.segment_options = [];
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.segment_options = response.data.data.options;
        this.saved_segment_options =  response.data.data.savedOptions;
      } else if (statusCode == 201) {
        //        AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    setSurveyToBuildRequired() {
      this.$parent.saveBuildRequired("Y");
    },
  },
  created() {},
  async mounted() {
    if (this.sectionObject.sectionType.name == "Functional Needs"){
      let vm = this;
      this.questions.sort(function(a, b) {
        let positionA = a.designViewSequenceNumber;
        let positionB = b.designViewSequenceNumber;
        return positionA - positionB;
      });
    }
    await NeedQuestionService.getNeedQuestionSegments(this.surveyId, this.getNeedQuestionSegmentsCallback, this);
    await NeedQuestionService.getNeedQuestionMetrics(this.surveyId, this.getNeedQuestionMetricsCallback, this);

    this.displayQuestions = true;
  }
};
</script>
